// ConfederationContext.js
import React, { createContext, useContext, useState } from 'react';

// Create context object
const ConfederationContext = createContext();

// Custom hook to use the context easily
export const useConfederation = () => useContext(ConfederationContext);

// Context provider component
export const ConfederationProvider = ({ children }) => {
  const [selectedConfederation, setSelectedConfederation] = useState('');

  return (
    <ConfederationContext.Provider value={{ selectedConfederation, setSelectedConfederation }}>
      {children}
    </ConfederationContext.Provider>
  );
};
